export default __webpack_public_path__ + "static/media/fig-08-face-orientation.b58c97df.png";